var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { either, pathOr, isEmpty, isNil, reduce, reduceRight, path, keys, partition, pick, pipe } from 'ramda';
import { message, Spin } from 'antd';
import { getToken } from 'apollo/client';
import { InboxOutlined } from '@ant-design/icons';
export var isNilOrEmpty = either(isNil, isEmpty);
/** Type guard for `.filter`: drops `null` and `undefined` and narrows the rest. */
export function isNotNil(value) {
    return value != null;
}
/** Normalizes a Select value (single, multiple or cleared) to a string array. */
export var toStringArray = function (value) {
    if (value == null || value === '')
        return [];
    return Array.isArray(value) ? value : [value];
};
export var createDeepResultObject = function (queryPath, data, typeNames) {
    if (data === void 0) { data = {}; }
    if (typeNames === void 0) { typeNames = {}; }
    return reduceRight(function (curr, acc) {
        var _a;
        return (_a = {},
            _a[curr] = __assign(__assign({}, acc), { __typename: typeNames[curr] || '' }),
            _a);
    }, data, queryPath);
};
export var createCustomDeepResultObject = function (queryPath, data, entitiesMeta) {
    if (data === void 0) { data = {}; }
    if (entitiesMeta === void 0) { entitiesMeta = {}; }
    return reduceRight(function (curr, acc) {
        var _a;
        return (_a = {},
            _a[curr] = __assign(__assign({}, acc), entitiesMeta[curr]),
            _a);
    }, data, queryPath);
};
export var getTypeNames = function (queryPath, previousResult) {
    return reduce(function (acc, curr) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[curr] = path(__spreadArray(__spreadArray([], keys(acc), true), [curr, '__typename'], false), previousResult), _a)));
    }, {}, queryPath);
};
export var getEntityMeta = function (queryPath, previousResult, fields) {
    return reduce(function (acc, curr) {
        var _a;
        return (__assign(__assign({}, acc), (_a = {}, _a[curr] = pipe(path(__spreadArray(__spreadArray([], keys(acc), true), [curr], false)), pick(fields))(previousResult), _a)));
    }, {}, queryPath);
};
export var getPhoneValues = function (refValue) {
    var phoneHasError = (refValue === null || refValue === void 0 ? void 0 : refValue.length) > 0 && refValue.match(/_/i);
    var phoneValue = refValue === null || refValue === void 0 ? void 0 : refValue.replace(/[^0-9]/gim, '');
    var phone_number = (phoneValue === null || phoneValue === void 0 ? void 0 : phoneValue.length) === 11 ? "+".concat(phoneValue) : phoneValue;
    return {
        phoneHasError: phoneHasError,
        phone_number: phone_number
    };
};
export var flattenGraphQLEdges = function (data) {
    var rootName = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        rootName[_i - 1] = arguments[_i];
    }
    return pathOr([], __spreadArray(__spreadArray([], rootName, true), ['edges'], false), data).map(function (item) {
        return pathOr({}, ['node'], item);
    });
};
export var filterBy = function (array, field) {
    var inArray = function (arr, item) {
        return arr.some(function (arrItem) { return arrItem[field] === item[field]; });
    };
    return array === null || array === void 0 ? void 0 : array.reduce(function (unique, item) { return (inArray(unique, item) ? unique : __spreadArray(__spreadArray([], unique, true), [item], false)); }, []);
};
export var showErrorMessage = function (error) {
    var msg = typeof error === 'string' ? error : (error === null || error === void 0 ? void 0 : error.message) || 'Unknown error';
    message.error("Error! ".concat(msg));
    console.warn(msg);
};
export var checkForErrors = function (dataPath, data, mute) {
    if (dataPath === void 0) { dataPath = []; }
    if (mute === void 0) { mute = false; }
    try {
        var error = pathOr(false, __spreadArray(__spreadArray([], dataPath, true), ['errors', 0, 'messages', 0], false), data);
        if (error)
            throw error;
    }
    catch (error) {
        if (!mute)
            showErrorMessage(error);
        else
            console.error(error);
        return false;
    }
    return true;
};
export var getInitials = function (person) {
    var first = (person === null || person === void 0 ? void 0 : person.first_name) ? person.first_name[0].toUpperCase() : '';
    var last = (person === null || person === void 0 ? void 0 : person.last_name) ? person.last_name[0].toUpperCase() : '';
    return first + last;
};
export var getBase64 = function (img, callback) {
    var reader = new FileReader();
    reader.addEventListener('load', function () { return callback(reader.result); });
    reader.readAsDataURL(img);
};
export var getIcon = function (icon, width, height, style, props) {
    if (width === void 0) { width = 32; }
    if (height === void 0) { height = 32; }
    if (style === void 0) { style = {}; }
    if (props === void 0) { props = {}; }
    return (_jsx("img", __assign({ src: icon, width: "".concat(width, "px"), height: "".concat(height, "px"), style: style, alt: "" }, props)));
};
export var organizationFilterForMember = function (filterValues) {
    var organization_id = filterValues.organization_id;
    return organization_id && { organization_id: organization_id };
};
export var enumerize = function (string) {
    return typeof string === 'string' ? string.toUpperCase().replace(/ /g, '_') : null;
};
export var formatMoney = function (value) {
    return "$".concat(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};
export var parseMoney = function (string) {
    return typeof string === 'string' ? string.replace(/\$\s?|(,*)/g, '') : '';
};
var blobUrlCache = new Map();
export var getBlobUrl = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    var options, errorMessage, response, status, blob, type, blobFile, blobUrl, error_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (blobUrlCache.has(url))
                    return [2 /*return*/, blobUrlCache.get(url)];
                options = {
                    method: 'GET',
                    headers: {
                        Authorization: String(getToken() || '')
                    }
                };
                errorMessage = 'The link has expired. Try to reload the page';
                _a.label = 1;
            case 1:
                _a.trys.push([1, 5, , 6]);
                return [4 /*yield*/, fetch("".concat(url), options)];
            case 2:
                response = _a.sent();
                status = response.status;
                if (status === 404) {
                    message.error(errorMessage);
                    return [2 /*return*/];
                }
                return [4 /*yield*/, response.blob()];
            case 3:
                blob = _a.sent();
                type = blob.type;
                return [4 /*yield*/, new File([blob], "".concat(url), { type: type })];
            case 4:
                blobFile = _a.sent();
                blobUrl = URL.createObjectURL(blobFile);
                if (blobUrl) {
                    blobUrlCache.set(url, blobUrl);
                    return [2 /*return*/, blobUrl];
                }
                message.error(errorMessage);
                return [3 /*break*/, 6];
            case 5:
                error_1 = _a.sent();
                message.error(error_1);
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}); };
export var getListWithBlobSrc = function (items, callback) { return __awaiter(void 0, void 0, void 0, function () {
    var filteredItems, ListWithBucketSrc;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                filteredItems = items.filter(function (i) { return i && !isEmpty(i); });
                return [4 /*yield*/, Promise.all(filteredItems.map(function (item) { return __awaiter(void 0, void 0, void 0, function () {
                        var _a;
                        var _b;
                        return __generator(this, function (_c) {
                            switch (_c.label) {
                                case 0:
                                    _a = [__assign({}, item)];
                                    _b = {};
                                    return [4 /*yield*/, getBlobUrl(item.short_url)];
                                case 1: return [2 /*return*/, (__assign.apply(void 0, _a.concat([(_b.src = _c.sent(), _b)])))];
                            }
                        });
                    }); }))];
            case 1:
                ListWithBucketSrc = _a.sent();
                return [2 /*return*/, callback(ListWithBucketSrc)];
        }
    });
}); };
// Sorts benefits by shooting ranges from 1st to 6th. The remaining values are located below.
// 'out_of_network' is always located at the very bottom.
export var sortBenefits = function (benefits, order) {
    var _a;
    if (order === void 0) { order = []; }
    var outOfNetworkId = ((_a = order === null || order === void 0 ? void 0 : order.find(function (t) { return t.code === 'out_of_network'; })) === null || _a === void 0 ? void 0 : _a.id) || '';
    var orderIds = (order === null || order === void 0 ? void 0 : order.map(function (t) { return t.id; })) || [];
    // divide tiersBenefits and others
    var dividedBenefits = partition(function (elem) {
        if (!(elem === null || elem === void 0 ? void 0 : elem.plan_benefit_tier_id))
            return false;
        return (orderIds.includes(elem.plan_benefit_tier_id) &&
            elem.plan_benefit_tier_id !== outOfNetworkId);
    }, benefits);
    // divide out_of_network
    var outDividedBenefits = partition(function (elem) { return elem.plan_benefit_tier_id === outOfNetworkId; }, dividedBenefits[1]);
    var sortedArray = __spreadArray(__spreadArray(__spreadArray([], dividedBenefits[0].sort(function (a, b) {
        return orderIds.indexOf(a.plan_benefit_tier_id) -
            orderIds.indexOf(b.plan_benefit_tier_id);
    }), true), outDividedBenefits[1], true), outDividedBenefits[0], true);
    return sortedArray.sort(function (a) {
        if (!a.plan_benefit_tier_id)
            return -1;
        return 0;
    });
};
export var dataLoader = function (loading) {
    return loading ? (_jsx("div", { style: { textAlign: 'center' }, children: _jsx(Spin, {}) })) : (_jsxs("div", { style: { textAlign: 'center', margin: '10px 0 0', color: 'lightgray' }, children: [_jsx(InboxOutlined, { style: { fontSize: 48 } }), _jsx("p", { children: "No Data" })] }));
};
export var groupByKey = function (list, key) {
    return list.reduce(function (hash, obj) {
        var _a;
        return (__assign(__assign({}, hash), (_a = {}, _a[obj[key]] = (hash[obj[key]] || []).concat(obj), _a)));
    }, {});
};
export var objectMap = function (obj, fn) {
    return Object.fromEntries(Object.entries(obj).map(function (_a, i) {
        var k = _a[0], v = _a[1];
        return [k, fn(v, k, i)];
    }));
};
// Helper function to create delay without promise executor return issue
export var sleep = function (ms) {
    return new Promise(function (resolve) {
        setTimeout(resolve, ms);
    });
};
export var mapMaxIndexToValue = function (dictionary) { return function () {
    var numbers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        numbers[_i] = arguments[_i];
    }
    return dictionary[numbers.indexOf(Math.max.apply(Math, numbers))];
}; };
